"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterHelper = void 0;
var _1 = require(".");
var Router_service_1 = require("../providers/Router.service");
exports.RouterHelper = {
    goTo: function (path, options) {
        if (options === void 0) { options = { openNewTab: false }; }
        if (options.openNewTab) {
            if (typeof window === "object") {
                window.open(path !== null && path !== void 0 ? path : undefined, "_blank");
            }
        }
        else {
            Router_service_1.RouterService.getInstance().goTo(path);
        }
    },
    onClickLinkEventHandler: function (event) {
        event.preventDefault();
        try {
            var anchorElement = event.currentTarget;
            var isDisabled = anchorElement.getAttribute("data-disabled");
            if (!(isDisabled === "true")) {
                var target = anchorElement.getAttribute("target");
                var href = anchorElement.getAttribute("href");
                var url = window.location.pathname;
                if (href && href.startsWith("./")) {
                    var updatedUrl = this.removeLastSegment(url) + '/' + this.processHref(href);
                    exports.RouterHelper.goTo(updatedUrl, { openNewTab: target === "_blank" });
                }
                else {
                    exports.RouterHelper.goTo(href, { openNewTab: target === "_blank" });
                }
            }
        }
        catch (error) {
            _1.ConsoleHelper.error("[Anchor ERROR] ", error);
        }
    },
    normalizeHref: function (href) {
        if (!_1.PageHelper.isHCLAuthoringPage() &&
            href &&
            href.match(/^\/tpdweb\/?/)) {
            return href.replace(/^\/tpdweb\/?/, "/");
        }
        else if (_1.PageHelper.isHCLAuthoringPage() &&
            href &&
            href.match(/^\/tpdweb\/?/)) {
            var projectName = _1.UrlHelper.getProjectNameFromUrl();
            if (projectName) {
                return "/myportal/$project/".concat(projectName).concat(href);
            }
            else
                return href;
        }
        else {
            return href || null;
        }
    },
    // Verifica se l'href inizia con "./" e lo rimuove se presente
    processHref: function (href) {
        if (!href)
            return "";
        return href.startsWith("./") ? href.slice(2) : href;
    },
    // Rimuove l'ultimo segmento dell'url
    removeLastSegment: function (url) {
        url = url.endsWith("/") ? url.slice(0, -1) : url;
        var lastSlashIndex = url.lastIndexOf("/");
        return lastSlashIndex !== -1 ? url.substring(0, lastSlashIndex) : url;
    }
};
